import { NavLink } from "react-router-dom";

//Navigation menu component
function Navigation(props) {
  return (
    <div
      className="ui menu secondary stackable four item"
      id="portfolioNavigation"
    >
      <div className="ui container navContainer" id="navContainer">
        {/* <a className="item" id="mainNavigationItem" href="/">
          <NavLink className="navLink" to="/">
            Home
          </NavLink>
        </a> */}
        <a className="item mainNavigationItem" href="/about">
          <NavLink
            activeClassName="portfolioSelected navLink"
            className="navLink"
            to="/about"
          >
            About
          </NavLink>
        </a>
        <a className="item mainNavigationItem" href="/services">
          <NavLink
            activeClassName="portfolioSelected navLink"
            className="navLink"
            to="/services"
          >
            Services
          </NavLink>
        </a>

        <a className="item mainNavigationItem" href="/clients">
          <NavLink
            activeClassName="portfolioSelected"
            className="navLink"
            to="/clients"
          >
            Clients
          </NavLink>
        </a>

        <a className="item mainNavigationItem" href="/contact">
          <NavLink
            activeClassName="portfolioSelected"
            className="navLink"
            to="/contact"
          >
            Contact
          </NavLink>
        </a>
      </div>
    </div>
  );
}

export default Navigation;
